
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-reading-context'
	});

	const { attributes, setAttributes } = props;
	const { text, caption } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-reading-context-content'>
				<RichText
					tagName='div'
					className='c4l-reading-context-text'
					multiline='p'
					value={text}
					onChange={(newVal) => setAttributes({ text: newVal })}
					placeholder={__("Type the reading content here", 'reading-context')}
				/>
				<RichText
					tagName='div'
					className='c4l-reading-context-caption'
					multiline='p'
					value={caption}
					onChange={(newVal) => setAttributes({ caption: newVal })}
					placeholder={__("AUTHOR NAME, Work Title", 'reading-context')}
				/>
			</div>
		</div>
	);
}
